import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import classnames from "classnames";

import useComponentVisible from "hooks/useComponentVisible";
import { NO_OP_FUNCTION } from "services/helpers";
import SvgIcon from "components/Common/SvgIcon";
import DatePicker from "components/Common/DatePicker";
import "./style.scss";

const BLOCK_NAME = "DatePickerDropdown";

export const DatePickerDropdown = (props) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const {
    placeholder,
    minDate,
    maxDate,
    displayDateFormat,
    valueDateFormat,
    optionalIconName,
    hasRange,
    selectedDate,
    onChange
  } = props;

  const displayDate = selectedDate && moment(selectedDate).utc().format(displayDateFormat);

  /**
   * Show or hide the entire dropdown menu
   */
  const toggleCalendar = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  /**
   * Set the start/end date
   * @param {String} nextDate
   */
  const handleCustomDateChange = (nextDate) => {
    const formattedSelectedDate = moment(nextDate).utc().format(valueDateFormat);

    onChange(formattedSelectedDate);
  };

  return (
    <div
      ref={ref}
      className={classnames(
        BLOCK_NAME, {
          [`${BLOCK_NAME}--open`]: isComponentVisible
        }
      )}
    >
      <button
        type="button"
        className={`${BLOCK_NAME}__header`}
        onClick={toggleCalendar}
      >
        {optionalIconName !== null && (
          <div className={`${BLOCK_NAME}__header-icon`}>
            <SvgIcon icon={optionalIconName} height={24} />
          </div>
        )}
        <div className={`${BLOCK_NAME}__header-title-container`}>
          <div className={`${BLOCK_NAME}__header-title`}>
            {(displayDate !== null) ? displayDate : placeholder}
          </div>
        </div>
        <div className={`${BLOCK_NAME}__header-arrow`}>
          <SvgIcon icon="ChevronDown" height={24} />
        </div>
      </button>
      {isComponentVisible && (
        <div className={`${BLOCK_NAME}__dropdown-container`}>
          <div className={`${BLOCK_NAME}__date-picker-container`}>
            <DatePicker
              activeInput="start"
              selectedDay={displayDate}
              minDate={minDate}
              maxDate={maxDate}
              onChange={handleCustomDateChange}
              hasRange={hasRange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

DatePickerDropdown.propTypes = {
  placeholder: PropTypes.string,
  selectedDate: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  onChange: PropTypes.func,
  displayDateFormat: PropTypes.string,
  valueDateFormat: PropTypes.string,
  hasRange: PropTypes.bool,
  optionalIconName: PropTypes.string
};

DatePickerDropdown.defaultProps = {
  placeholder: "Select Date",
  selectedDate: null,
  minDate: null,
  maxDate: null,
  onChange: NO_OP_FUNCTION,
  displayDateFormat: "LL",
  valueDateFormat: "YYYY-MM-DD",
  hasRange: false,
  optionalIconName: "Calendar"
};

export default DatePickerDropdown;
